<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="查看" fontSize="14px" :useAutoOptional="false"
				:optional="sbmidarr.length !== 1" @btnclick="Look"
				:src="require('@/assets/icon/look.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" :title="secTitle" fontSize="14px" @btnclick="deactivate"
				:src="secImg">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="上传文件" :uploadType="2" fontSize="14px" @getFiles="uploadFiles" types="UploadAll"
				:src="require('@/assets/icon/daoc.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="seImport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" @click="SeconDowload">导入模版下载</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="comtable" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum="7" :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="1000px" title="驳回原因" :dialogVisible="RejectReasondialogVisibles" @cancel="RejectReasoncancel"
			@dialogOK="RejectReasondialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonPic" style="width: 600px;">
			</el-input>
		</DialogFrom>

		<DialogFrom width="1000px" :title="EidtTitle" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item, index) of fromdataadd">
					<Commondropdownlist ref="addjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
						:options="item.options" @remoteMethodtows="remoteMethodtows" :key="index"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled">
					</Commondropdownlist>
				</template>
				<div class="Upload" v-if="EidtTitle!='查看'"
					style="display: flex;align-items: center;padding: 18px 28px;">
					<div class="Title" style="font-size: 14px;color: rgb(51, 51, 51);margin-right: 18px;">
						附件上传：
					</div>
					<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;" backgroundColor="#FFF" title="上传"
						fontSize="14px" @getFile="getFileDsphImg" types="fileImg"
						:src="require('@/assets/icon/icon-drjys.png')">
					</CommonbtnUpLoad>
				</div>
				<div class="SMSProviderFlex"
					style="padding: 12px 20px 0px;display: flex;justify-content: space-between;flex-wrap: wrap;">
					<FilesAndPictures class="FilesAndPictures" :DelFlag="true" v-for="(item, index) of imgUploadData"
						:key="index" :fileAddImgData="item" @See="See($event,index)" @Del="Del($event,index)">
					</FilesAndPictures>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum="100" :tableData="tableDatadrjg"
					height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条档案吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要{{ secTitle }}这条档案吗？</span>
		</Dialog>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogeVisibledeactivate"
			@cancel="dialogeVisibledeactivate = false" @dialogOK="dialogeOKdeactivate"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要{{ seceTitle }}这条档案吗？</span>
		</Dialog>
		<Picturepreview :imgsrc="imgsrc" :show="imgShow" @hidefn="imgHide"></Picturepreview>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
	import Commontable from "../../../../components/common-table.vue";
	import Commonbtn from "../../../../components/common-btn.vue";
	import Pagination from "../../../../components/pagination.vue";
	import DialogFrom from "../../../../components/dialog-from.vue";
	import Picturepreview from "../../../../components/picturepreview.vue";
	import fromdata from "../fromData/add";
	import fromdataedit from "../fromData/edit";
	import Dialog from "../../../../components/dialog.vue";
	import CommonbtnUpLoad from "../../../../components/common-upload.vue";
	import headerData from "../tableData/headerData";
	import rejectHeaderData from "../tableData/rejectHeaderData";
	import BLdetailstable from "../tableData/BLdetailstable";
	import FilesAndPictures from "@/components/FilesAndPictures.vue";
	import {
		CustomerList,
		CustomerEdit,
		CustomerDelete,
		CustomeDownloadAreaListr,
		OpenAccountReject,
	} from "@/api/home";
	import {
		GetCusRelationCustomerInfo,
		UploadAttachmentByEdit,
		UploadAttachmentCusRelationCustomer,
		AddCusRelationCustomer,
		ActiveCusRelationCustomer,
		DeactiveCusRelationCustomer,
		DownloadCusRelationCustomer,
		ImportCusRelationCustomer,
	} from "@/api/newsapi";
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonbtnUpLoad,
			Picturepreview,
			FilesAndPictures,
		},
		props: {
			tableData: {
				type: Array,
				default: [],
			},
			total: {
				type: Number,
				default: 0,
			},
		},
		data: function() {
			return {
				sbmidarr: [],
				imgUploadData: [],
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesdrjg: false,
				rejectdialogVisibles: false,
				RejectReasondialogVisibles: false,
				dwonleft: false,
				rowboo: false,
				imgsrc: "",
				imgShow: false,
				RejectStatus: true,
				rejecttotal: null,
				CompanyID: "",
				fromdataadd: [],
				fromdataedit: [],
				fromdatapadd: [],
				tableDatadrjg: [],
				checkboxets: [],
				rejectTable: [],
				BLdetailstable: [],
				openaccount: null,
				cusinfo: null,
				salerbusinessauthority: null,
				commitmentletter: null,
				affiliatestatement: null,
				filecontact: null,
				BLdetailsTableData: null,
				BusdetailsTableData: null,
				RedetailsTableData: null,
				CommitmentLetterData: null,
				openaccountData: null,
				cusinfoData: null,
				salerbusinessauthorityData: null,
				affiliatestatementData: null,
				filecontactData: null,
				RejectpageSize: 10,
				Rejectpageindex: 1,
				cusCode: "",
				cusId: "",
				AEflig: 1,
				title: "",
				RejectReasonPic: "",
				detailsTitle: "",
				RejectedIndex: "", //记录驳回下拉框的index
				EidtTitle: "",
				secImg: require("@/assets/icon/icon-stop.png"),
				secTitle: "停用",
				seceTitle: "停止合作",
				from: {
					orgCusCode: "",
					newCusCode: "",
					attachmentNames: [],
				},
				headerData: [],
				rejectHeaderData: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false,
					License: false, //证照
				},
				UnVerifyLicenseCount: null, //待审核证照数量
				ValidLicenseCount: null, //有效证照数量
				RejectLicenseCount: null, //被驳回证照数量
				license: null, //营业执照部分
				permission: null, //医疗器械经营许可证部分
				record: null, //第二类医疗器械备案凭证部分
				status: null,
				enabled: 1,
				RejectReason: "", //驳回原因
				provinceVisibles: false,
				dialogeVisibledeactivate: false,
			};
		},
		mounted() {
			this.BLdetailstable = JSON.parse(JSON.stringify(BLdetailstable));
			this.rejectHeaderData = JSON.parse(JSON.stringify(rejectHeaderData));
			this.headerData = JSON.parse(JSON.stringify(headerData));
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata));
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit));
			this.QX();
		},
		methods: {
			handleSelectionChange(val) {
				this.sbmidarr = val.map(it => it.ID);
				if (val.length === 1) {
					this.setCurrentCustomer(val[0]);
					this.rowboo = true;
					return;
				}
				this.rowboo = false;
				if (val.length === 0) {
					this.clearCurrentCustomer();
				}
			},
			setCurrentCustomer(val) {
				this.UnVerifyLicenseCount = val.UnVerifyLicenseCount;
				this.ValidLicenseCount = val.ValidLicenseCount;
				this.RejectLicenseCount = val.RejectLicenseCount;
				this.cusId = val.ID;
				this.cusCode = val.CusCode;
				this.CompanyID = val.CompanyID;
				if (val.Enabled == 1) {
					this.secImg = require("@/assets/icon/icon-stop.png");
					this.secTitle = "停用";
				}
				if (val.Enabled == 0) {
					this.secImg = require("@/assets/icon/qy.png");
					this.secTitle = "启用";
				}
				if (val.CooperateStatus == 1) {
					this.secImg = require("@/assets/icon/icon-stop.png");
					this.seceTitle = "停止合作";
				}
				if (val.CooperateStatus == 0) {
					this.secImg = require("@/assets/icon/qy.png");
					this.seceTitle = "合作";
				}
			},
			clearCurrentCustomer() {
				this.cusId = "";
				this.cusCode = "";
				this.CompanyID = "";
				this.UnVerifyLicenseCount = null;
				this.ValidLicenseCount = null;
				this.RejectLicenseCount = null;
			},
			See(par) {
				if (
					par.Extension == "jpg" ||
					par.Extension == "png" ||
					par.Extension == "gif"
				) {
					this.imgShow = true;
					this.imgsrc = par.FileUrl;
					console.log(this.imgsrc);
				} else if (par.Extension == "pdf") {
					window.open(par.FileUrl, "_blank");
				} else {
					window.location.href = par.FileUrl;
				}
			},
			Del(e, i) {
				this.imgUploadData.splice(i, 1);
			},
			async remoteMethodtows(query) {
				this.loading = true;
				let {
					code,
					data
				} = await CustomerList({
					cusName: query,
				});
				if (code == 0) {
					this.fromdataedit[0].options = [];
					this.fromdataadd[0].options = [];
					this.fromdataedit[1].options = [];
					this.fromdataadd[1].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName,
						};
						this.fromdataedit[0].options.push(obj);
						this.fromdataadd[0].options.push(obj);
						this.fromdataedit[1].options.push(obj);
						this.fromdataadd[1].options.push(obj);
						this.$forceUpdate();
						console.log(this.fromdataadd);
					});
					this.loading = false;
				}
			},
			//上传附件
			async getFileDsphImg(e) {
				let formData = new FormData();
				formData.append('files', e);

				let {
					data,
					code,
					message
				} = await UploadAttachmentByEdit(formData);
				if (code == 0) {
					this.imgUploadData.push(data[0]);
					this.$message({
						type: 'success',
						message: '上传成功'
					});
					//this.$parent.customerList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 33) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 166) {
								this.qus = items.Nodes;
							}
						});
					}
					// console.log(this.qus, 'this.qus');
				});
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "stopif") {
							this.qx.del = true;
						} else if (item.NodeName == "assignment") {
							this.qx.assignment = true;
						} else if (item.NodeName == "enabled") {
							this.qx.enabled = true;
						} else if (item.NodeName == "skip") {
							this.qx.skip = true;
						} else if (item.NodeName == "reset") {
							this.qx.reset = true;
						} else if (item.NodeName == "setting") {
							this.qx.setting = true;
						} else if (item.NodeName == "License") {
							this.qx.License = true;
							this.LicenseRList = this.LicenseRLists;
						}
					});
				}
			},
			//下载模板
			Dowload(index) {
				if (index == 0) {
					this.SeconDowload();
				}
				if (index == 1) {
					this.CityDowload("经销商引入评估");
				}
			},
			imgHide() {
				this.imgShow = false;
			},
			// 导入
			async customerImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)",
					});
					let formData = new FormData();
					formData.append("file", file);
					let res = await ImportCusRelationCustomer(formData);
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: res.message,
						});
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message,
						});
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = res.data;
						this.title = "导入结果";
						this.$message({
							type: "error",
							message: res.message,
						});
						loading.close();
					}
					loading.close();
				}
			},
			// 导入
			seImport(file) {
				this.customerImport(file);
			},
			//上传文件
			uploadFiles(files) {
				if (!this.sbmidarr.length) {
					this.$message({
						type: "error",
						message: "请选择要操作的数据！",
					});
					return;
				}
				this.uploadCustomerFile(files);
			},

			// 上传文件
			async uploadCustomerFile(files) {
				console.log(2222, files);
				if (files) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)",
					});
					let formData = new FormData();
					for (var i = 0; i < files.length; i++) {
						formData.append("files", files[i]);
					}
					let res = await UploadAttachmentCusRelationCustomer(this.sbmidarr.join(','), formData);
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: res.message,
						});
						this.sbmidarr = [];
						this.$refs.comtable.$refs.multipleTable.clearSelection();
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message,
						});
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = res.data;
						this.title = "导入结果";
						this.$message({
							type: "error",
							message: res.message,
						});
						loading.close();
					}
					loading.close();
				}
			},
			// 下载导入模板
			async customerDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await DownloadCusRelationCustomer({});
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message,
					});
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			SeconDowload() {
				this.customerDownloadTemplet();
			},
			async customeDownloadAreaListr() {
				let {
					data,
					code,
					message
				} = await CustomeDownloadAreaListr({});
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message,
					});
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			CityDowload() {
				this.customeDownloadAreaListr();
			},

			// 详情
			async customerInfo() {
				let {
					code,
					data
				} = await GetCusRelationCustomerInfo({
					id: this.cusId,
				});
				if (code == 0) {
					this.$refs.addjxa[0].modelvalue = data.OrgCusName;
					this.$refs.addjxa[1].modelvalue = data.NewCusName;
					this.imgUploadData = data.lstAttachments;
				}
			},
			// 查看
			Look() {
				if (this.sbmidarr.length === 1) {
					this.AEflig = 3;
					this.dialogVisibles = true;
					this.EidtTitle = "查看";
					this.customerInfo();
					return;
				}
				this.$message({
					type: "error",
					message: "请选择要操作的数据！",
				});
			},
			// 修改
			async customerEdit(datalist) {
				let {
					code,
					message
				} = await CustomerEdit({
					cusCode: datalist[0].modelvalue,
					cusName: datalist[1].modelvalue,
					cusType: datalist[2].modelvalue == null ? 0 : datalist[2].modelvalue,
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "修改成功",
					});
					this.rowboo = false;
					this.$parent.customerList();
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			// 删除
			async customerDelete() {
				let {
					code,
					message
				} = await CustomerDelete({
					cusCode: this.cusCode,
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功",
					});
					this.rowboo = false;
					this.$parent.customerList();
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			// 停用
			async customerSetActive() {
				if (this.secTitle == "启用") {
					let delIds = [];
					delIds.push(this.cusId);
					let {
						code,
						message
					} = await ActiveCusRelationCustomer({
						ids: delIds,
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "启用成功",
						});
						this.rowboo = false;
						this.$parent.customerList();
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				} else {
					let delIds = [];
					delIds.push(this.cusId);
					let {
						code,
						message
					} = await DeactiveCusRelationCustomer({
						ids: delIds,
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "停用成功",
						});

						this.rowboo = false;
						this.$parent.customerList();
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				}
			},
			onRowClick(val) {
				this.setCurrentCustomer(val);
				this.rowboo = this.sbmidarr.length <= 1;
			},
			adduser() {
				this.AEflig = 1;
				this.dialogVisibles = true;
				this.imgUploadData = [];
				this.EidtTitle = "新增";
			},

			cancel() {
				this.dialogVisibles = false;
			},
			dialogOK() {
				if (this.EidtTitle == "查看") {
					this.dialogVisibles = false;
				} else if (this.EidtTitle == "新增") {
					this.from.orgCusCode = this.$refs.addjxa[0].modelvalue;
					this.from.newCusCode = this.$refs.addjxa[1].modelvalue;
					this.from.AttachmentNames = this.imgUploadData.map(it => it.FileName);
					this.customerAdd();
				}
			},
			// 新增
			async customerAdd() {
				let {
					code,
					message
				} = await AddCusRelationCustomer({
					orgCusCode: this.from.orgCusCode,
					newCusCode: this.from.newCusCode,
					attachmentNames: this.from.AttachmentNames
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "新增成功",
					});
					this.rowboo = false;
					this.$parent.customerList();
					this.$refs.addjxa.map((item, index) => {
						if (index == 10) {
							item.radio = "1";
						}
						item.modelvalue = "";
					});
					this.dialogVisibles = false;
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			Export() {
				this.$emit("Export");
			},
			canceledit() {
				this.dialogVisiblesedit = false;
			},
			dialogOKedit() {
				if (this.AEflig == 2) {
					this.customerEdit(this.$refs.secupdate);
					this.dialogVisiblesedit = false;
				} else if (this.AEflig == 3) {
					this.dialogVisiblesedit = false;
				}
			},

			del() {
				if (this.rowboo == true) {
					this.dialogVisibledel = true;
					return;
				}
				this.$message({
					type: "error",
					message: "请选择要删除的数据！",
				});
			},
			canceldel() {
				this.dialogVisibledel = false;
			},
			dialogOKdel() {
				this.customerDelete();
				this.dialogVisibledel = false;
			},
			deactivate() {
				if (this.rowboo == true) {
					this.dialogVisibledeactivate = true;
					return;
				}
				this.$message({
					type: "error",
					message: "请选择要停用的数据！",
				});
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false;
			},
			dialogOKdeactivate() {
				this.customerSetActive();
				this.dialogVisibledeactivate = false;
			},
			dialogeOKdeactivate() {
				this.customereSetActive();
				this.dialogeVisibledeactivate = false;
			},
			// 驳回
			async OpenAccountReject(OAID) {
				let {
					code,
					data,
					message
				} = await OpenAccountReject({
					OAID: OAID,
					RejectReason: this.RejectReasonPic,
				});
				if (code == 0) {
					this.$message.success("驳回成功");
				} else {
					this.$message.warning(message);
				}
			},
			See(par) {
				if (
					par.Extension == "jpg" ||
					par.Extension == "png" ||
					par.Extension == "gif"
				) {
					this.imgShow = true;
					this.imgsrc = par.FileUrl;
				} else if (par.Extension == "pdf") {
					window.open(par.FileUrl, "_blank");
				} else {
					window.location.href = par.FileUrl;
				}
			},
			handleCurrentChange(pageindex) {
				this.$emit("handleCurrentChange", pageindex);
			},
			handleSizeChange(paegSzie) {
				this.$emit("handleSizeChange", paegSzie);
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false;
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false;
			},
			RejectReasoncancel() {
				this.RejectReasondialogVisibles = false;
			},
			RejectReasondialogOK() {
				if (this.RejectedIndex == 0) {
					this.OpenAccountReject(this.openaccount.OAID);
				} else if (this.RejectedIndex == 1) {
					this.OpenAccountReject(this.cusinfo.OAID);
				} else if (this.RejectedIndex == 2) {
					this.OpenAccountReject(this.salerbusinessauthority.OAID);
				} else if (this.RejectedIndex == 3) {
					this.OpenAccountReject(this.commitmentletter.OAID);
				} else if (this.RejectedIndex == 4) {
					this.OpenAccountReject(this.affiliatestatement.OAID);
				} else if (this.RejectedIndex == 5) {
					this.OpenAccountReject(this.filecontact.OAID);
				}
				this.RejectReasondialogVisibles = false;
			},
		},

		watch: {
			dialogVisibles: {
				handler(newList, oldList) {
					if (newList == false) {
						this.$refs.addjxa.map((item, index) => {
							if (index == 10) {
								item.radio = "1";
							}
							item.modelvalue = "";
						});
					}
				},
				deep: true,
			},
			rejectdialogVisibles: {
				handler(newList, oldList) {
					if (newList) {
						this.BusdetailsTableData = null;
						this.RedetailsTableData = null;
						this.CommitmentLetterData = null;
						this.filecontactData = null;
						this.openaccountData = null;
						this.cusinfoData = null;
						this.salerbusinessauthorityData = null;
						this.affiliatestatementData = null;
						this.BLdetailsTableData = null;
						this.detailsTitle = "";
					}
				},
				deep: true,
			},

			EidtTitle: {
				handler(newVal, oldVal) {
					if (newVal == "查看") {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = true;
						});
					} else if (newVal == "新增") {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = false;
						});
					}
				},
			},
		},
	};
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.fileList {
			width: 100%;
			height: 100%;
			// border: 1px solid red;
			margin-top: 30px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.file {
				line-height: 32px;
				border-radius: 2px;
				border: 1px solid #e6e6e6;
				cursor: pointer;
				display: inline-block;
				position: relative;
				width: 440px;
				height: 32px;
				color: #000000;
				font-size: 12px;
				background-color: #fafbfc;
				margin-top: 10px;

				.fileName {
					display: inline-block;
					font-size: 14px;
					margin-left: 20px;
					max-width: 320px;
					// border: 1px solid red;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.cz {
					display: flex;
					width: 90px;
					font-size: 14px;
					float: right;
					color: #e71d43;

					.fileSee {
						display: inline-block;
						margin-left: 10px;
					}

					.fileDel {
						display: inline-block;
						margin-left: 10px;
					}
				}
			}
		}

		.Upload {
			height: 100%;
			width: 100%;
			//   border: 1px solid red;
			margin-top: 30px;

			.UploadTitle {
				font-size: 14px;
				font-weight: normal;
				color: #424e66;
			}

			.Enclosure {
				margin-left: -45px;
			}

			.Remarks {
				font-size: 14px;
				font-weight: normal;
				color: #9ca5b7;
			}
		}

		.line {
			width: 100%;
			height: 1px;
			background: #eaecef;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
			margin-top: 30px;
		}

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.Code {
		width: 100%;
	}

	.type {
		width: 98.6%;
		border: 1px solid #e6e6e6;
		font-size: 17px;
		color: #333333;
		font-weight: 500;
		padding: 10px 10px 10px 0;
		margin: 0 auto;

		.type-top {
			width: 100%;
			border-bottom: 1px solid #e6e6e6;
			font-weight: bold;
			color: #333333;
			font-size: 14px;
			text-indent: 16px;
			line-height: 16px;
			padding-bottom: 10px;

			.type-top-left {
				width: 3px;
				height: 16px;
				display: inline-block;
				background-color: #e71d43;
				float: left;
			}
		}

		.type-text {
			margin-top: 12px;
		}

		.CodeText {
			display: inline-block;
			width: 430px;
			margin-left: 30px;
			font-size: 14px;
			font-weight: 500;
			// border: 1px solid red;
			color: #999999;
			margin-top: 12px;
			position: relative;

			.imgBox {
				display: inline-block;
				width: 96px;
				height: 96px;
				border: 1px solid #e6e6e6;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}

			span {
				display: inline-block;
				color: #333333;
				font-weight: 500;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}
		}
	}

	.LicenseRfrom {
		width: 100%;
		height: 500px;
		overflow: scroll;
	}

	.detailedCss {
		min-width: 100px;
		max-width: 200px;
		height: 32px;
		background-color: #fce8ec;
		border: 1px solid #e71d43;
		color: #e71d43;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin: 10px 10px 10px 0;
	}

	.imgTop {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 75px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop2 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 145px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop3 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 175px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop4 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 130px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}
</style>
